module.exports = __webpack_public_path__ + "bac116fb96390120fae1a618f65d4ca6.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/design_grey.png
// module id = 224
// module chunks = 0